/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';

import { useSessionData } from '@confluence/session-data';
import { fg } from '@confluence/feature-gating';
import { markErrorAsHandled } from '@confluence/graphql';

import type {
	useIsLoomEntryPointsEnabledQuery as useIsLoomEntryPointsEnabledQuery$data,
	useIsLoomEntryPointsEnabledQueryVariables as useIsLoomEntryPointsEnabledQuery$variables,
} from './__types__/useIsLoomEntryPointsEnabledQuery';

export const useIsLoomEntryPointsEnabled = () => {
	const { cloudId } = useSessionData();

	const { data, error, loading } = useQuery<
		useIsLoomEntryPointsEnabledQuery$data,
		useIsLoomEntryPointsEnabledQuery$variables
	>(
		gql`
			query useIsLoomEntryPointsEnabledQuery($cloudId: ID!) {
				confluence_loomEntryPoints(cloudId: $cloudId) {
					isLoomEntryPointsEnabled
				}
			}
		`,
		{
			variables: {
				cloudId,
			},
		},
	);

	return useMemo(() => {
		if (!fg('confluence_loom_entry_points')) {
			return true;
		}

		if (error) {
			markErrorAsHandled(error);
			return true;
		}

		if (!loading && data) {
			return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
		}
	}, [data, error, loading]);
};
